import { memo, useCallback, useState } from 'react';

import { Button } from '@/shadcn/button';
import { DialogClose, DialogFooter } from '@/shadcn/dialog';

import { MultipleValuesTextArea } from '@/components/ui/multipleValuesTextArea/multipleValuesTextArea';
import { TestId } from '@/types/testId';
import { pluralize } from '@/utils';
import { newEmailValidation } from './addUsers.utils';

type Props = {
  submit: (emails: string[]) => void;
};

// Modal content to add a set of users from their emails
export const AddUsers = memo(({ submit }: Props) => {
  // state for handling list of emails
  const [emails, setEmails] = useState<string[]>([]);

  // callback to report if a new string value can be added to the list of emails
  const validateNewEmail = useCallback(
    (str: string) => newEmailValidation(str, emails),
    [emails]
  );

  return (
    <>
      <MultipleValuesTextArea
        errorFn={validateNewEmail}
        splitKeys={[' ', 'Enter', 'Tab']}
        toLowerCase
        updateValues={setEmails}
        values={emails}
      />
      <DialogFooter>
        <DialogClose asChild>
          <Button data-testid={TestId.AddUsers.CancelButton} variant="outline">
            cancel
          </Button>
        </DialogClose>

        <Button
          data-testid={TestId.AddUsers.SubmitButton}
          disabled={!emails.length}
          onClick={() => submit(emails)}
        >
          {emails.length
            ? `Add ${pluralize(emails.length, 'participant', false, true)}`
            : 'Add participant'}
        </Button>
      </DialogFooter>
    </>
  );
});
